import  {  useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS
import "./Blogshow.css";
import { useNavigate } from "react-router-dom";

function Categoryadd() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_API_URL;
  const [data, setData] = useState({
    name: "",
    description: "",
  });

  // wnd new integration
  const onChangehanndler = (event) => {
    const { name, value } = event.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const onsubmithandler = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${url}/api/category/add`,
        data,
        {
          headers: { token },
        }
      );

      if (response.data.success) {
        setData({ name: "", description: "" });
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while submitting the category.");
      console.error(error);
    }
  };

  return (
    <div className="container mt-5">
      <button
        className="btn btn-outline-primary my-2"
        onClick={() => navigate(`/category-management/index`)}
      >
        <i className="fa fa-list mx-1"></i>
        List Category
      </button>

      <ToastContainer />
      <form
        onSubmit={onsubmithandler}
        className="border p-4 rounded shadow-sm bg-light"
      >
        <h3 className="text-center mb-4">Add Category</h3>

        {/* Name */}
        <div className="form-group mb-3">
          <label htmlFor="name" className="required-field">
            <i className="fa fa-tag me-2"></i>Name
          </label>
          <input
            type="text"
            name="name"
            required
            value={data.name}
            onChange={onChangehanndler}
            className="form-control"
            placeholder="Enter category name"
          />
        </div>

        {/* Description */}
        <div className="form-group mb-3">
          <label htmlFor="description" className="required-field">
            <i className="fa fa-info-circle me-2"></i>Description
          </label>
          <textarea
            name="description"
            value={data.description}
            onChange={onChangehanndler}
            className="form-control"
            rows="4"
            placeholder="Enter description"
          />
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button type="submit" className="btn btn-primary px-5 py-2">
            <i className="fa fa-paper-plane me-2"></i>Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default Categoryadd;
